export default __webpack_public_path__ + "static/media/79.f4e7f267.jpeg";